import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "edit", "editing", "enable", "group" ]
  static values = { state: String }

  edit(e) {
    this.stateValue = "edit"
    e.preventDefault()
  }

  cancel(e) {
    this.stateValue = "disabled"
    e.preventDefault()
  }

  stateValueChanged() {
    this.editTargets.forEach((el) => {
      if (this.stateValue == 'edit') {
        el.classList.add("edit-hidden")
      } else {
        el.classList.remove("edit-hidden")
      }
    })
    this.editingTargets.forEach((el) => {
      if (this.stateValue != 'edit') {
        el.classList.add("edit-hidden")
      } else {
        el.classList.remove("edit-hidden")
      }
    })
    this.enableTargets.forEach((el) => {
      el.disabled = (this.stateValue != 'edit')
    })
    this.groupTargets.forEach((el) => {
      if (this.stateValue != 'edit') {
        el.classList.add("disabled-group")
      } else {
        el.classList.remove("disabled-group")
      }
    })
  }

}